import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import HelpSectionComponent from './sub-help/HelpSection';
import '../index.scss';

export default function HelpComponent() {
    const [activeKey, setActiveKey] = useState();

    useEffect(() => {
        let tabVal = sessionStorage.getItem("activeKeySubTab");
        if (tabVal) {
            setActiveKey(tabVal);
        }
    }, []);

    const changeTab = (activeKey) => {
        setActiveKey(activeKey);
        sessionStorage.setItem("activeKeySubTab", activeKey);
        if (activeKey == "1") {
            sessionStorage.setItem("userRole", "ORGANIZATION_ADMIN");
        } else if (activeKey == "2") {
            sessionStorage.setItem("userRole", "PARTNER_ADMIN");
        } else if (activeKey == "3") {
            sessionStorage.setItem("userRole", "END_USER");
        }
    };

    return (
        <div className="tabContainer-help">
            <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={changeTab}>
                <Tabs.TabPane tab="Organisation" key={"1"}>
                    <HelpSectionComponent userRole={'ORGANIZATION_ADMIN'} title="Organisation" />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Partner" key={"2"}>
                    <HelpSectionComponent userRole={'PARTNER_ADMIN'} title="Partner" />
                </Tabs.TabPane>
                <Tabs.TabPane tab="End User" key={"3"}>
                    <HelpSectionComponent userRole={'END_USER'} title="End User" />
                </Tabs.TabPane>
            </Tabs>
        </div>
    )
}